export const CompensationMatrixAnalysisMatchingFile = 'step1_matching.json'
